var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome6Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 19.9998C21.8 20.5521 21.3523 20.9998 20.8 20.9998H4.80005C4.24777 20.9998 3.80005 20.5521 3.80005 19.9998V9.48883C3.80005 9.18024 3.94252 8.88893 4.18611 8.69948L12.1861 2.47725C12.5472 2.19639 13.0528 2.19639 13.4139 2.47725L21.4139 8.69948C21.6575 8.88893 21.8 9.18024 21.8 9.48883V19.9998ZM7.80005 14.9998V16.9998H17.8V14.9998H7.80005Z",
    fill: "#FFE700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome6Fill);
export default __webpack_public_path__ + "static/media/home-6-fill.cf692b4c2829ca8542b890c9a09b50d7.svg";
export { ForwardRef as ReactComponent };